import React from 'react';

import { Theme, withStyles, WithTheme } from '@material-ui/core';
import { Field, FieldConfig } from 'formik';

import ColorPicker from './ColorPicker';

export interface FieldThemeProps extends FieldConfig<Partial<Theme>>, WithTheme {}

const FieldTheme: React.FC<FieldThemeProps> = ({ name, value, theme, ...rest }) => (
  <div>
    <Field name={`${name}.palette.primary.main`} {...rest}>
      {({ field, form }: any) => (
        <ColorPicker
          value={field.value || theme.palette.primary.main}
          onChange={(newValue) => form.setFieldValue(field.name, newValue)}
        />
      )}
    </Field>
    {/* TODO: Add MUI theme fields */}
  </div>
);

export default withStyles({}, { withTheme: true })(FieldTheme);
